// extracted by mini-css-extract-plugin
export var downArrow = "_9q-0";
export var infoTooltipIcon = "_9q-3";
export var label = "_9q-1";
export var optionCard = "_9q-4";
export var upArrow = "_9q-2";